import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { companyInfo } from "../mock";
import { CookieSettingsLink } from "./CookieBanner";

export const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="text-2xl font-bold mb-4">
              <span className="text-[#143e6e]">wirkaufendein</span>
              <span className="text-[#1f7db6]">Laptop</span>
              <span className="text-[#143e6e]">.de</span>
            </div>
            <p className="text-gray-600 mb-4 max-w-md">
              Ankauf von gebrauchten Laptops und Smartphones - für Unternehmen (ab 20 Geräte) und Privatkunden.
            </p>
            <div className="space-y-2 text-sm text-gray-600">
              <div className="flex items-center space-x-2">
                <Mail size={16} className="text-[#1f7db6]" />
                <a href={`mailto:${companyInfo.email}`} className="hover:text-[#1f7db6] transition-colors">
                  {companyInfo.email}
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <Phone size={16} className="text-[#1f7db6]" />
                <a href={`tel:${companyInfo.phone.replace(/\s/g, '')}`} className="hover:text-[#1f7db6] transition-colors">
                  {companyInfo.phone}
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <MapPin size={16} className="text-[#1f7db6]" />
                <span>{companyInfo.address}</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Services</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/laptop-purchase" className="text-gray-600 hover:text-[#1f7db6] transition-colors">
                  Laptop-Ankauf
                </Link>
              </li>
              <li>
                <Link to="/bulk-remarketing" className="text-gray-600 hover:text-[#1f7db6] transition-colors">
                  Großmengen & IT-Remarketing
                </Link>
              </li>
              <li>
                <Link to="/data-security" className="text-gray-600 hover:text-[#1f7db6] transition-colors">
                  Datenlöschung & Sicherheit
                </Link>
              </li>
              <li>
                <Link to="/process" className="text-gray-600 hover:text-[#1f7db6] transition-colors">
                  Ablauf & Logistik
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Unternehmen</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="text-gray-600 hover:text-[#1f7db6] transition-colors">
                  Über uns
                </Link>
              </li>
              <li>
                <Link to="/request-quote" className="text-gray-600 hover:text-[#1f7db6] transition-colors">
                  Angebot anfragen
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-8 pt-8 text-center text-sm text-gray-600">
          <p>&copy; {new Date().getFullYear()} ReTech IT GbR. Alle Rechte vorbehalten.</p>
          <p className="mt-2 text-gray-600">
            Sofortangebote für Privatkunden • B2B-Service ab 20 Geräten
          </p>
          <div className="mt-3 flex justify-center space-x-4">
            <Link to="/impressum" className="text-[#1f7db6] hover:text-[#143e6e] transition-colors">
              Impressum
            </Link>
            <span className="text-gray-400">|</span>
            <Link to="/datenschutz" className="text-[#1f7db6] hover:text-[#143e6e] transition-colors">
              Datenschutz
            </Link>
            <span className="text-gray-400">|</span>
            <CookieSettingsLink className="text-[#1f7db6] hover:text-[#143e6e] transition-colors" />
          </div>
        </div>
      </div>
    </footer>
  );
};
